import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';

type EventSuccessBuyData = {
    value: number;
};

export class EventSuccessBuyHandler {
    public handle(data: EventSuccessBuyData): void {
        ClientEventEmitter.fireEvent(ClientEvents.SUCCESS_BUY, { amount: data.value });
    }
}
